import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferGameServiceUploadEditQuery, OfferDigitalUpdateQuery } from './type';

/**
 * 修改数字商品offer
  PUT /product/offerManage/updateDigitalOffer
  接口ID：263628552
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628552
 */
export const putOfferDigitalProductEditUpload = (data: OfferDigitalUpdateQuery): AxiosPromise => {
  return request({
    url: '/product/offerManage/updateDigitalOffer',
    method: 'put',
    data
  });
};

/**
 * 修改game service offer
  POST /product/offerManage/updateGameServiceOffer
  接口ID：263628554
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628554
 */
export const putOfferGameServiceEditUpload = (data: OfferGameServiceUploadEditQuery): AxiosPromise => {
  return request({
    url: '/product/offerManage/updateGameServiceOffer',
    method: 'post',
    data
  });
};
